import { render, staticRenderFns } from "./TournamentAdmin.vue?vue&type=template&id=f0a25ec2&"
import script from "./TournamentAdmin.vue?vue&type=script&lang=js&"
export * from "./TournamentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TournamentAdmin.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentAdmin.vue"
export default component.exports